module.exports = __webpack_public_path__ + "static/img/1.48f7981.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/1.png
// module id = AoDn
// module chunks = 0